import { EditFilled, UndoOutlined } from "@ant-design/icons";
import { Button, Tooltip } from "antd";
import classNames from "classnames";
import { usePaldockTranslation } from "hooks/usePaldockTranslation";

interface FormFieldOverrideButtonProps {
    overridden: boolean;
    onToggle: () => void;
    className?: string;
}

export const FormFieldOverrideButton = ({ overridden, onToggle, className }: FormFieldOverrideButtonProps) => {
    const { t } = usePaldockTranslation("forms.form-field-settings");
    const label = t(overridden ? "overrides.use_source" : "overrides.override_value");

    return (
        <Tooltip title={label}>
            <Button
                type="text"
                size="small"
                className={classNames("!bg-transparent !text-[#FAAD14] !shadow-none", className)}
                icon={overridden ? <UndoOutlined /> : <EditFilled />}
                aria-label={label}
                onClick={onToggle}
            />
        </Tooltip>
    );
};
